module.exports = __webpack_public_path__ + "images/LoginPageVector.240adc2a.svg";